import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { environment } from 'src/environments/environment';
import { FiltroBuscaService } from '../service/filtro-busca-service/filtro-busca.service';

@Component({
  selector: 'app-filtro-detalhes-obra',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownToggleDirective],
  templateUrl: './filtro-detalhes-obra.component.html',
  styleUrl: './filtro-detalhes-obra.component.scss',
})
export class FiltroDetalhesObraComponent {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  filtroDetalhesObra: Array<any> = [];

  @Input() bloqueandoAtualizacao: boolean = false;
  @Input() idModuloSelecionado: number;
  @Input() detalhesSelecionados: any[] = [];
  @Output() detalhesChange = new EventEmitter<any[]>();

  private subscriptions = new Subscription();

  constructor(
    private readonly _filtroBuscaService: FiltroBuscaService,
    private readonly _errorHandleService: ErrorHandleService,
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: any) {
    if (this.idModuloSelecionado === 234 || this.bloqueandoAtualizacao) {
      return;
    }
    this.detalhesDaObra();
    if (changes.detalhesSelecionados && this.filtroDetalhesObra.length > 0) {
      this.sincronizarDetalhesSelecionados();
    }
  }

  sincronizarDetalhesSelecionados() {
    if (!Array.isArray(this.detalhesSelecionados)) return;
    const selecionadosIds = this.detalhesSelecionados.map((d) => d.id);
    this.filtroDetalhesObra.forEach((item) => {
      item.checked = selecionadosIds.includes(item.id);
    });
  }

  onDetalheChange() {
    const selecionados = this.filtroDetalhesObra.filter((o) => o['checked']);
    this.detalhesChange.emit(selecionados);
  }

  detalhesDaObra() {
    this.subscriptions.add(
      this._filtroBuscaService
        .filtroDetalhesDaObra(this.idModuloSelecionado)
        .subscribe({
          next: (res) => {
            if (res.success) {
              this.filtroDetalhesObra = res.data;
              this.sincronizarDetalhesSelecionados();
              this._errorHandleService.throwConsoleError(res.message);
            }
          },
          error: (err) => {
            console.error('Erro na API:', err);
            this._errorHandleService.throwConsoleError('Erro ao buscar dados.');
          },
        }),
    );
  }
}
